import { PublicLayout } from '../layout/PublicLayout';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { Link } from 'react-router';
import { ArrowRight } from 'lucide-react';
import { useSEO } from '@/hooks/useSEO';
import { comparisons } from '../data/comparisons';

export const CompareHubPage = () => {
  useSEO({
    title: 'Compare Raisy - AI Workforce OS vs Other Tools',
    description:
      'See how Raisy, the AI workforce operating system, compares to LLM APIs and automation tools — structure, transparency, KPIs, memory, and setup effort side by side.',
    keywords:
      'raisy comparison, AI workforce platform comparison, claude alternative, AI agent orchestration comparison',
    ogTitle: 'Compare Raisy',
    ogDescription:
      'Honest, side-by-side comparisons of Raisy vs LLM APIs and automation tools.',
    ogType: 'website',
    canonicalUrl: 'https://raisy.team/compare',
  });

  return (
    <PublicLayout>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <div className="mb-12">
          <Badge className="mb-4 bg-cyan-100 dark:bg-cyan-900/30 text-cyan-700 dark:text-cyan-400 hover:bg-cyan-100 dark:hover:bg-cyan-900/40">
            Comparisons
          </Badge>
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 dark:text-white mb-4">
            Compare Raisy
          </h1>
          <p className="text-xl text-slate-600 dark:text-slate-300">
            Honest, side-by-side looks at how the Raisy AI workforce operating
            system stacks up against models, APIs, and automation tools —
            including where the other option is the better choice.
          </p>
        </div>

        <div className="space-y-6">
          {comparisons.map((comparison) => (
            <Card
              key={comparison.slug}
              className="border-slate-200 dark:border-slate-700"
            >
              <CardHeader>
                <CardTitle className="text-2xl text-slate-900 dark:text-white">
                  Raisy vs {comparison.competitorName}
                </CardTitle>
                <CardDescription className="text-base text-slate-600 dark:text-slate-400">
                  {comparison.badge}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-slate-700 dark:text-slate-300 mb-6">
                  {comparison.subheadline}
                </p>
                <Link to={`/compare/${comparison.slug}`}>
                  <Button className="bg-cyan-600 hover:bg-cyan-700">
                    Read the comparison{' '}
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Button>
                </Link>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </PublicLayout>
  );
};
